<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-transparent md-absolute"
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start" @click="accueil">
        <img src="../assets/img/logo.png" alt="" />
        <h3 class="md-title">Gréliane Dagbédji</h3>
      </div>

      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list>
              <md-list-item href="/">
                <i class="material-icons">home</i>
                <div class="mt-2">{{ $t("header.accueil") }}</div>
              </md-list-item>
              <md-list-item href="#/etude">
                <i class="material-icons">school</i>
                <div class="mt-2">{{ $t("header.etude") }}</div>
              </md-list-item>

              <md-list-item href="#/voyage">
                <i class="material-icons">airplanemode_active</i>
                <div class="mt-2">{{ $t("header.voyage") }}</div>
              </md-list-item>

              <md-list-item href="#/travail">
                <i class="material-icons">work</i>
                <div class="mt-2">{{ $t("header.travail") }}</div>
              </md-list-item>

              <md-list-item href="#/affaire">
                <i class="material-icons">work</i>
                <div class="mt-2">{{ $t("header.affaire") }}</div>
              </md-list-item>

              <md-list-item href="#/assurance">
                <i class="material-icons">airport_shuttle</i>
                <div class="mt-2">{{ $t("header.assurance") }}</div>
              </md-list-item>

<!--              <md-list-item href="#" target="_blank">-->
<!--                <i class="fab fa-twitter"></i>-->
<!--                <p class="hidden-lg">Twitter</p>-->
<!--                <md-tooltip md-direction="bottom">-->
<!--                  {{ $t("header.twitter") }}-->
<!--                </md-tooltip>-->
<!--              </md-list-item>-->
              <md-list-item
                href="https://www.facebook.com/R%C3%A9v%C3%A9lation-Travel-101999314996471"
                target="_blank"
              >
                <i class="fab fa-facebook-square"></i>
                <p class="hidden-lg">Facebook</p>
                <md-tooltip md-direction="bottom">{{
                  $t("header.facebook")
                }}</md-tooltip>
              </md-list-item>

              <md-list-item @click="openWhatsapp">
                <i class="fab fa-whatsapp"></i>
                <p class="hidden-lg">Whatsapp</p>
                <md-tooltip md-direction="bottom">
                 Envoyer un message
                </md-tooltip>
              </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import MobileMenu from "@/layout/MobileMenu";
export default {
  components: {
    MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false
    };
  },

  computed: {
    showDownload() {
      const excludedRoutes = ["login", "landing", "profile"];
      return excludedRoutes.every(r => r !== this.$route.name);
    }
  },

  methods: {
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },

    openWhatsapp() {
      window.open('https://api.whatsapp.com/send?phone=1(631)2531166&text=Bonjour', '_blank')
    },

    accueil() {
      this.$router.push("/");
    },

    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },

    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `md-${this.type}`;
        navbarColor.classList.remove("md-transparent");
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = "";
          navbarColor.classList.add("md-transparent");
        }
      }
    },

    scrollListener() {
      resizeThrottler(this.handleScroll);
    },

    scrollToElement() {
      let element_id = document.getElementById("downloadSection");
      if (element_id) {
        element_id.scrollIntoView({ block: "end", behavior: "smooth" });
      }
    }
  },

  mounted() {
    document.addEventListener("scroll", this.scrollListener);
  },

  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  }
};
</script>
